'use strict'

var request = require('fitt-http')
var debug = require('debug')('http-memoizr')
var config = require('./config')

function Memoizr(options) {

  if (!(this instanceof Memoizr)) {
    return new Memoizr(options)
  }

  options = options || {}

  this.memcached = require('./lib/memcached')(options)
  this.origin = options.origin || ''
  this.timeout = options.timeout || 1000
  this.headers = options.headers || undefined
}

Memoizr.prototype.get = function (url, options) {

  options = options || {}

  url = this.origin + url

  var cacheKey = options.key || url
  var force = options.force || false
  var headers = options.headers || this.headers || {}

  var parseJSON = options.parseJSON === undefined ? true : options.parseJSON

  var memcached = this.memcached
  var timeout = options.timeout || this.timeout

  if (!!memcached && (typeof memcached.get === 'function' && typeof memcached
      .set === 'function')) {
    debug('Memcached successfully inited')

    function fetchAndUpdateMemcached() {
      debug('Making a new request')
      return request.get(url, {
        timeout: timeout,
        headers: headers
      }).then(function (res) {
        debug('Response received', res)

        var valueToSet = res[options.prop || 'data']
        if (parseJSON && typeof(valueToSet) === 'object') {
          // assume it's a JSON object. Danger will robinson!
          valueToSet = JSON.stringify(valueToSet)
        }

        memcached.set(cacheKey, valueToSet, options.duration ||
          config.duration,
          function (err) {
            if (!err) {
              debug('Set memcached key', cacheKey)
            }
          })
        return res
      })
    }

    return new Promise(function (resolve, reject) {

      if (force) {
        return resolve(fetchAndUpdateMemcached())
      }

      memcached.get(cacheKey, function (err, data) {
        if (typeof data !== 'undefined' && !err && !force) {
          debug('Data available in memcached', data)

          if (parseJSON) {
            try {
              var tempData = JSON.parse(data)
              if (tempData) {
                data = tempData
              }
            } catch (parseException) {
              debug('Exception parsing JSON: leaving data alone: ' + parseException)
            }
          }

          resolve({
            data: data,
            cached: true
          })

        } else {
          resolve(fetchAndUpdateMemcached())
        }
      })
    })
  } else {
    debug('Memcached failed to init, possibly a browser')
    return request.get(url)
  }
}

module.exports = Memoizr




// WEBPACK FOOTER //
// ./lib/http-memoizr/src/index.js